import { NgOptimizedImage } from '@angular/common';
import { ChangeDetectionStrategy, Component, input, OnInit } from '@angular/core';
import { RouterLink } from '@angular/router';
import { CdnPathPipe } from '@uc/utilities';
import { ImpressionDirective, UniversityGTMService } from '@uc/web/core';
import { Product, ProductEnum, RecommendedUniversity } from '@uc/web/shared/data-models';
import { RecommendedVisitWebsiteBtnComponent } from '../../components/recommended-visit-website-btn/recommended-visit-website-btn.component';

@Component({
	selector: 'uc-recommended-uni-card',
	templateUrl: './recommended-uni-card.component.html',
	imports: [
		RouterLink,
		NgOptimizedImage,
		CdnPathPipe,
		ImpressionDirective,
		RecommendedVisitWebsiteBtnComponent,
	],
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RecommendedUniCardComponent implements OnInit {
	uni = input.required<RecommendedUniversity>();
	product = input.required<Product>();
	componentName!: 'UG Carousel' | 'PG Carousel' | 'CLE Carousel';

	constructor(private _uniGTMSrv: UniversityGTMService) {}

	ngOnInit(): void {
		this.componentName =
			this.product() === ProductEnum.Undergraduate
				? 'UG Carousel'
				: this.product() === ProductEnum.Postgraduate
					? 'PG Carousel'
					: 'CLE Carousel';
	}

	onUniImpression(impression: any) {
		const ugso =
			this.product() === ProductEnum.Undergraduate ? this.uni().order : null;
		const cleso = this.product() === ProductEnum.Clearing ? this.uni().order : null;

		if (impression) {
			this._uniGTMSrv.uniImpression(
				this.uni().id,
				this.uni().name,
				ugso,
				cleso,
				this.product(),
			);
		}
	}
}
